import React from 'react';

import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Form } from '@/components/ui/form';
import { Alert } from '../../../../shared/components/Alert';
import { InputField, SubmitButton } from '../../../../shared/components/Form';
import Header from '../components/Header';
import { ERROR_TITLES, SUCCESS_MESSAGES } from '../constants';
import { useForgotPasswordForm } from '../hooks';

const alertIcon = <FontAwesomeIcon icon={faCircleExclamation} />;

const ForgotPassword = () => {
  const {
    error,
    form,
    handleSubmit: onSubmit,
    isSubmitting,
    submissionSuccessful,
  } = useForgotPasswordForm();

  return (
    <div className="flex items-center justify-center bg-muted min-h-svh">
      <div className="flex flex-col gap-6 w-full max-w-xs">
        <Header title="Forgot Password" />

        <Form {...form}>
          <form className="flex flex-col gap-6" onSubmit={form.handleSubmit(onSubmit)}>
            <InputField control={form.control} label="Email" name="email" type="email" />
            <SubmitButton isLoading={isSubmitting}>Send Reset Link</SubmitButton>

            {submissionSuccessful && !form.formState.isDirty && (
              <Alert
                description={SUCCESS_MESSAGES.password.request.description}
                icon={alertIcon}
                title={SUCCESS_MESSAGES.password.request.title}
                variant="success"
              />
            )}

            {error && (
              <Alert
                description={error.message}
                icon={alertIcon}
                title={ERROR_TITLES.password.request}
                variant="destructive"
              />
            )}
          </form>
        </Form>
      </div>
    </div>
  );
};

export default ForgotPassword;
